import config from "../../../config";
import sendRequest from "../../../helpers/requestHelper";
import eventBus from "../../../event-bus/eventBus";

const deleteProject = {
    namespaced: true,
    state: {
        isLoadingDeleteModal: false,
        modalDeleteData: {},
        isShowDeleteModal: false,
        modalDeleteInfoData: {},
        isShowDeleteModalInfo: false
    },
    mutations: {
        SHOW_MODAL_DELETE_DATA(state, modalDeleteData) {
            state.modalDeleteData.typeInfo = "primary";
            state.modalDeleteData.head = modalDeleteData.languageData.head;
            state.modalDeleteData.btnAgreeText = modalDeleteData.languageData.btnAgreeText;
            state.modalDeleteData.textInfo = modalDeleteData.languageData.textInfoProject+' '+modalDeleteData.name;
            state.modalDeleteData.idData = modalDeleteData.id;
            state.modalDeleteData.index = modalDeleteData.index;
            state.isShowDeleteModal = true;
        },
        DELETE_PROJECT_SUCCESS(state, deleteData) {
            state.modalDeleteInfoData.typeInfo = "green";
            state.modalDeleteInfoData.head = deleteData.result.data.message;
            state.modalDeleteInfoData.textInfo = deleteData.result.data.data.textInfo;
            eventBus.$emit("deleteItem", deleteData.id, deleteData.result.data.data.invoiceExists);
        },
        DELETE_PROJECT_FAILURE(state, error) {
            console.log(error);
        },
        HIDE_MODAL_DELETE_ACTION(state, value) {
            state.isShowDeleteModal = value;
        },
        HIDE_MODAL_DELETE_INFO_ACTION(state, value) {
            state.isShowDeleteModalInfo = value;
        }
    },
    actions: {
        showModalDeleteData: function({commit}, modalDeleteData) {
            commit("SHOW_MODAL_DELETE_DATA", modalDeleteData);
        },
        deleteProjectRequest: function({state, dispatch}, value) {
            state.isLoadingDeleteModal = true;
            let promise = sendRequest("delete", config.baseURLApi + "/projects/" + value, {});
            promise.then(function(result) {
                if(result[0] === "success") {
                    let deleteData = {};
                    deleteData.result = result[1];
                    deleteData.id = value;
                    dispatch("successDeleteProject", deleteData);
                } else {
                    dispatch("failureDeleteProject", result[1]);
                }
                state.isLoadingDeleteModal = false;
                state.isShowDeleteModal = false;
                state.isShowDeleteModalInfo = true;
            })
        },
        successDeleteProject: function({commit}, response) {
            commit("DELETE_PROJECT_SUCCESS", response);
        },
        failureDeleteProject: function({commit}, error) {
            commit("DELETE_PROJECT_FAILURE", error);
        },
        hideModalDeleteAction({ commit }) {
            commit("HIDE_MODAL_DELETE_ACTION", false);
        },
        hideModalDeleteInfoAction({ commit }) {
            commit("HIDE_MODAL_DELETE_INFO_ACTION", false);
        }
    }
}

export default deleteProject;